import React from "react";

const FedralCredit = () => {
  const schoolData = [
    {
      "Bank Name": "America First Federal Credit Union",
      Address: "4774 S 1300 W BLDG # 3, PO BOX 9199, RIVERDALE, UT 84409-0199",
      "CEO/President": "Thayne Shaffer, President",
      "Contact No:": "801-627-0900",
    },
    {
      "Bank Name": "American United Federal CU",
      Address: "2687 W 7800 S, WEST JORDAN, UT 84088",
      "CEO/President": "Jake Bowman, President",
      "Contact No:": "801-583-5015",
    },
    {
      "Bank Name": "Ascent Federal Credit Union",
      Address: "4140 HARRISON BLVD, OGDEN, UT 84403",
      "CEO/President": "Brock Mortensen, President",
      "Contact No:": "801-399-9728",
    },
    {
      "Bank Name": "C U P Federal Credit Union",
      Address: "302 E 1860 S, PO BOX 50526, PROVO, UT 84605-0526",
      "CEO/President": "Lin Thompson, President",
      "Contact No:": "801-374-1170",
    },
    {
      "Bank Name": "Cyprus Federal Credit Union",
      Address:
        "3876 W CENTER VIEW WAY, PO BOX 9002, WEST JORDAN, UT 84084-5661",
      "CEO/President": "Todd E. Adamson, President",
      "Contact No:": "801-260-7600",
    },
    {
      "Bank Name": "Deseret First Federal Credit Union",
      Address: "3999 W PKWY BLVD, WEST VALLEY CITY, UT 84120",
      "CEO/President": "Shane London, President",
      "Contact No:": "801-456-7000",
    },
    {
      "Bank Name": "Desert Rivers Federal Credit Union",
      Address: "725 N MAIN, PO BOX 1047, MOAB, UT 84532-1047",
      "CEO/President": "Samuel Crane, President",
      "Contact No:": "435-259-6124",
    },
    {
      "Bank Name": "Desertview Federal Credit Union",
      Address: "196 N MAIN, PO BOX 580, HUNTINGTON, UT 84528",
      "CEO/President": "Michael H. Nelson, President",
      "Contact No:": "435-687-2472",
    },
    {
      "Bank Name": "Devils Slide Federal Credit Union",
      Address: "243 E 125 N, PO BOX 588, MORGAN, UT 84050",
      "CEO/President": "Jill J. Carrigan, President",
      "Contact No:": "801-829-6900",
    },
    {
      "Bank Name": "Eastern Utah Community Federal CU",
      Address: "675 E 100 N, PO BOX 719,PRICE, UT 84501-0719",
      "CEO/President": "Bruce Yost, President",
      "Contact No:": "435-637-2443",
    },
    {
      "Bank Name": "Elevate Federal Credit Union",
      Address: "1023 S MEDICAL DR, PO BOX 624, BRIGHAM CITY, UT 84302",
      "CEO/President": "Scott Webre, President",
      "Contact No:": "435-723-3437",
    },
    {
      "Bank Name": "Flexpak Federal Credit Union",
      Address: "1993 W 2425 S, WOODS CROSS, UT 84087",
      "CEO/President": "Ralph Jenkins, President",
      "Contact No:": "801-485-1052",
    },
    {
      "Bank Name": "Gibbons & Reed Emp. Federal CU",
      Address: "1000 WARM SPRINGS RD, PO BOX 30429, SALT LAKE CITY, UT 84130",
      "CEO/President": "L.William Christopherson, President",
      "Contact No:": "801-322-4010",
    },
    {
      "Bank Name": "Goldenwest Federal Credit Union",
      Address: "5025 S ADAMS, PO BOX 1111, OGDEN, UT 84402",
      "CEO/President": "Kerry Wahlen, President",
      "Contact No:": "801-337-8300",
    },
    {
      "Bank Name": "Granite Federal Credit Union",
      Address: "3675 S 900 E, SALT LAKE CITY, UT 84106-1964",
      "CEO/President": "Mark Young, President",
      "Contact No:": "801-288-3000",
    },
    {
      "Bank Name": "Hercules First Federal Credit Union",
      Address: "3141 W 4700 S, PO BOX 26977,SALT LAKE CITY, UT 84126-0977",
      "CEO/President": "Brett Blackburn, President",
      "Contact No:": "801-968-9011",
    },
    {
      "Bank Name": "Horizon Utah Federal Credit Union",
      Address: "225 S 200 W, PO BOX 687,FARMINGTON, UT 84025-0687",
      "CEO/President": "W. Page Bennett, President",
      "Contact No:": "801-451-5064",
    },
    {
      "Bank Name": "Jordan Federal Credit Union",
      Address: "1750 W 11400 S #200, SOUTH JORDAN, UT 84095",
      "CEO/President": "Lindsey Merritt, President",
      "Contact No:": "801-566-4195",
    },
    {
      "Bank Name": "Logan Cache Rich Federal CU",
      Address: "72 E 700 N, LOGAN, UT 84321",
      "CEO/President": "Jordan Burdge, President",
      "Contact No:": "435-563-6882",
    },
    {
      "Bank Name": "Logan Medical Federal CU",
      Address: "500 E 1400 N, LOGAN, UT 84341",
      "CEO/President": "Dale D. Howe, President",
      "Contact No:": "435-716-5392",
    },
    {
      "Bank Name": "LU 354 I B E W Federal Credit Union",
      Address: "3405 W 1987 S, SALT LAKE CITY, UT 84104-4942",
      "CEO/President": "Linda J. Perschon, President",
      "Contact No:": "801-975-9693",
    },
    {
      "Bank Name": "Mountain America Federal CU",
      Address: "9800 MONROE ST, SANDY, UT 84070",
      "CEO/President": "Sterling W. Nielsen, President",
      "Contact No:": "801-325-6228",
    },
    {
      "Bank Name": "Nephi Western Employees Federal CU",
      Address: "155 N MAIN ST, PO BOX 252, NEPHI, UT 84648",
      "CEO/President": "Mark Drake, President",
      "Contact No:": "435-623-1895",
    },
    {
      "Bank Name": "North Sanpete Federal Credit Union",
      Address: "11917 E 24711 N, FAIRVIEW, UT 84629",
      "CEO/President": "Jessica Clare, President",
      "Contact No:": "435-462-9075",
    },
    {
      "Bank Name": "Orem City Employees Federal CU",
      Address: "56 N STATE ST, OREM, UT 84057",
      "CEO/President": "Kendall Adamson, President",
      "Contact No:": "801-229-7168",
    },
    {
      "Bank Name": "Ridgeline Federal Credit Union",
      Address: "564 E 300 S, SALT LAKE CITY, UT 84102-4021",
      "CEO/President": "Doug C. Huntsman, President",
      "Contact No:": "801-328-1521",
    },
    {
      "Bank Name": "University First Federal Cr. Union",
      Address:
        "3450 S HIGHLAND DR STE 201, PO BOX 58025, SALT LAKE CITY, UT 84158",
      "CEO/President": "Jack Buttars, President",
      "Contact No:": "801-481-8800",
    },
    {
      "Bank Name": "Utah Community Federal Credit Union",
      Address: "360 W 4800 N, PROVO, UT 84604",
      "CEO/President": "Bret VanAusdal, President",
      "Contact No:": "801-223-8188",
    },
    {
      "Bank Name": "Utah First Federal Credit Union",
      Address: "200 E S TEMPLE, PO BOX 2197, SALT LAKE CITY, UT 84111",
      "CEO/President": "Darin B. Moody, President",
      "Contact No:": "801-320-2600",
    },
    {
      "Bank Name": "Valley Wide Federal CU",
      Address: "1330 E HIGHWAY 40, PO BOX 461, VERNAL, UT 84078",
      "CEO/President": "Monica Marchant, President",
      "Contact No:": "435-789-6918",
    },
    {
      "Bank Name": "Varex Federal CU",
      Address: "1678 S PIONEER RD, SALT LAKE CITY, UT 84104-4205",
      "CEO/President": "Tammy Phillips, President",
      "Contact No:": "801-973-5052",
    },
    {
      "Bank Name": "Wasatch Peaks Federal CU",
      Address: "4723 HARRISON BLVD, OGDEN, UT 84403-4304",
      "CEO/President": "Jeff Shaw, President",
      "Contact No:": "801-627-8700",
    },
  ];
  return (
    <div className="flex items-center justify-center my-12">
      <div className="bg-gray-300 z-10 rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
        <div className="overflow-x-auto max-h-[800px]">
          <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
            <thead className="sticky top-0 z-10">
              <tr>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                  Bank Name
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                  Address
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                  CEO
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                  President
                </th>
              </tr>
            </thead>
            <tbody>
              {schoolData.map((school, index) => (
                <tr
                  key={school.sn}
                  className="odd:bg-white even:bg-gray-100 hover:bg-gray-200"
                >
                  <td className="border border-gray-300 px-4 py-2 text-center text-blue-900">
                    {school["Bank Name"]}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center text-blue-900">
                    {school.Address}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 font-bold text-blue-900">
                    {school["CEO/President"]}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-blue-900">
                    {school["Contact No:"]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FedralCredit;
